import {
	Avatar,
	Box,
	Breadcrumbs,
	Button,
	Chip,
	Container,
	Divider,
	Grid,
	IconButton,
	Link,
	Modal,
	TextField,
	Tooltip,
	Typography,
	Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    CircularProgress,
    List,
    ListItemButton,
    ListItemText,
    ListItemIcon,
    ListItem,
	useTheme,
} from "@mui/material";
import React, { useState } from "react";
import * as Yup from "yup";

import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useNavigate, useParams } from "react-router-dom";
import queryGraphql from "../../helpers/ApiInterface";
import moment from "moment";
import { useAuth } from "../../helpers/AuthProvider";
import { Close } from "@mui/icons-material";
import { Formik, ErrorMessage, Form } from "formik";

import CompulsoryFieldsLabel from "../../helpers/CompulsoryFields";
import MiniBot from "../MiniBot";
import MainDrawer, { openDrawerWidth, collapsedDrawerWidth } from "../MainDrawer"; // Adjust path if needed
const ApplicationApproveFormPageContent: React.FC = () => {
	const navigate = useNavigate();
	const { id } = useParams();
	const { user } = useAuth();
	const [application, setApplication] = useState<any>({});
	const [config, setConfig] = useState<any>({});
	const [openRejectModal, setOpenRejectModal] = useState(false);
	const [openApproveModal, setOpenApproveModal] = useState(false);
	const [resourceStatus, setResourceStatus] = useState<any>({});
	const fallback = '-'; // Fallback value for safety

	React.useEffect(()=>{
		const fetchData = async () =>{
			try{
				const data = await queryGraphql(`query ResourceStatus($resourceStatusId: String!) {
  resourceStatus(id: $resourceStatusId) {
    id
    resourceId
    resourceName
    currentStatus
    resourceType
    resourceEnvironment
    resourceOwner {
      id
      name
    }
    projectUrl
    gcpClusterUrl
    argoCdStaticUrl
    subGroupProjectAppUrl
    subGroupProjectInfraUrl
    createdAt
    updatedAt
  }
}`, {resourceStatusId: id});
if(data.resourceStatus){
	// console.dir(data.cluster);
	setResourceStatus(data.resourceStatus);
	
}
			}
			catch(error){
				console.log(error);
			}
		}
		fetchData();
	},[]);
	

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const data = await queryGraphql(
					`
                        query($applicationId: String!){
                        application(id:$applicationId) {
						id,
                        applicationName,
                        cluster{
                        id,
                        clusterName,
						vpcProjectId,
                        },
                        environment,
                        gcpApplicationViewers,
                        serviceRequesters,
                        costLabelPairs{
                        cost,
                        label
                        },
                        status,
                        createdAt,
                        actionedAt,
                        applicationOwner{
                        id,
                        name,
                        googleProfilePicture,
                        }
                        applicationApprover{
                        id,
                        name,
                        googleProfilePicture,
                        },
                        reasonForRejection

                        }
                        }
`,
					{ applicationId: id }
				);
				if (data.application) {
					setApplication(data.application);
				}
			} catch (error) {
				console.log(error);
			}
		};

		fetchData();
	}, []);
	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const data = await queryGraphql(
					`
                        query GetConfig {
  getConfig {
    emailIDP
    appBucket
    company {
      bu
      name
    }
    factfileBucket
    gitlabDomainUrl
    gitlabParentUrl
    gitlabSecretRefToken
	gitlabSecretRefTokenFaraday
    id
    platformBucket
    gcpProjectId
    serviceAccountGKE
    serviceAccountRunner
    serviceAccountVM
  }
}
`,
					// { applicationId: id }
				);
				if (data.getConfig) {
					setConfig(data.getConfig);
				}
			} catch (error) {
				console.log(error);
			}
		};

		fetchData();
	}, []);
	return (
		<Container disableGutters maxWidth={false} sx={{ bgcolor: "#fafafa", minHeight: "100vh" }}>
				<MiniBot/>
			<Box sx={{ p: 2, bgcolor: "#FFFFFF" }}>
				<Breadcrumbs aria-label="breadcrumb" sx={{ fontSize: "0.875rem", color: "gray" }}>
					<Link underline="hover" color="inherit" href="/requests/applications">
						Requests
					</Link>
					<Typography color="text.primary">Request Details</Typography>
				</Breadcrumbs>
				<Box display="flex" alignItems="center" mt={1}>
					<IconButton
						edge="start"
						aria-label="back"
						color="inherit"
						onClick={() => navigate("/requests/applications")}
					>
						<ArrowBackIosNewIcon fontSize="small" />
					</IconButton>
					<Typography fontFamily="Gilroy-Bold" fontSize="18px">
						Request Details
					</Typography>
				</Box>
			</Box>
			<Grid container>
				<Grid item xs={0.5} />
				<Grid item xs={11}>
					{application.id && (
						<Box>
							<Typography fontSize="16px" my={1}>
								Review the application
							</Typography>
							<Box mx={4}>
								<Box
									bgcolor={
										application.status == "active"
											? "#12B76A10"
											: application.status == "rejected"
											? "#F0443810"
											: "#FDB02210"
									}
									justifyContent="space-between"
									alignItems="center"
									display="flex"
									borderRadius="12px 12px 0px 0px"
									p={2}
									boxShadow={1}
								>
									<Box>
										<Typography fontSize="14px">Application Details</Typography>
										<Typography fontFamily="Gilroy-Regular" fontSize="12px">{`Requested By: ${
											application.applicationOwner?.name
										} | On: ${moment(new Date(Number(application.createdAt)).toISOString()).format(
											"DD/MM/YYYY"
										)}`}</Typography>
									</Box>
									<Box alignItems="center">
										<Box sx={{ display: "flex", alignItems: "center" }}>
											<img
												src={
													application.status == "active"
														? "/assets/tickcircle.svg"
														: application.status == "rejected"
														? "/assets/reject.svg"
														: "/assets/clock.svg"
												}
												alt="Icon"
												style={{ width: "20px", marginRight: "8px" }}
											/>
											<Typography fontSize="16px" fontFamily="Gilroy-SemiBold">
												{application.status == "active"
													? "Active"
													: application.status == "rejected"
													? "Rejected"
													: "Pending Approval"}
											</Typography>
										</Box>
										{(application.status == "active" || application.status == "rejected") && (
											<Typography fontSize="12px" fontFamily="Gilroy-Regular">{`On: ${moment(
												new Date(Number(application.actionedAt)).toISOString()
											).format("DD/MM/YYYY")}`}</Typography>
										)}
									</Box>
								</Box>

								<Box bgcolor="#fff" p={2} borderRadius="0px 0px 12px 12px" boxShadow={1}>
									<Grid container>
										<Grid item xs={2.4}>
											<Box>
												<Typography fontFamily="Gilroy-Regular" fontSize="12px">
													Application Name
												</Typography>
												<Typography fontFamily="Gilroy-Semibold" fontSize="14px">
													{application.applicationName}
												</Typography>
											</Box>
										</Grid>
										<Grid item xs={2.4}>
											<Box>
												<Typography fontFamily="Gilroy-Regular" fontSize="12px">
													Cluster Name
												</Typography>
												<Typography fontFamily="Gilroy-Semibold" fontSize="14px">
													{application.cluster?.clusterName}
												</Typography>
											</Box>
										</Grid>
										<Grid item xs={2.4}>
											<Box>
												<Typography fontFamily="Gilroy-Regular" fontSize="12px">
													Application Owner
												</Typography>
												<Box display="flex" alignItems="center" justifyContent="flex-start">
													<Avatar
														sx={{ height: "20px", width: "20px", marginRight: 0.5 }}
														src={application.applicationOwner?.googleProfilePicture}
													/>
													<Typography fontFamily="Gilroy-Semibold" fontSize="14px">
														{application.applicationOwner?.name}
													</Typography>
												</Box>
											</Box>
										</Grid>
										<Grid item xs={2.4}>
											<Box>
												<Typography fontFamily="Gilroy-Regular" fontSize="12px">
													Environment
												</Typography>
												<Typography fontFamily="Gilroy-Semibold" fontSize="14px">
													{application.environment}
												</Typography>
											</Box>
										</Grid>
										<Grid item xs={2.4}>
											<Box>
												<Typography fontFamily="Gilroy-Regular" fontSize="12px">
													Application Viewers
												</Typography>
												<Box display="flex" alignItems="center" justifyContent="flex-start">
													{application.gcpApplicationViewers?.map((e: string) => {
														return (
															<Tooltip title={e}>
																<Avatar
																	sx={{ height: "20px", width: "20px", marginRight: 0.5 }}
																	src={e}
																	alt={e}
																/>
															</Tooltip>
														);
													})}
												</Box>
											</Box>
										</Grid>
									</Grid>
									<Grid container mt={2}>
										<Grid item xs={2.4}>
											<Box>
												<Typography fontFamily="Gilroy-Regular" fontSize="12px">
													Service Owners
												</Typography>
												<Box display="flex" alignItems="center" justifyContent="flex-start">
													{application.serviceRequesters?.map((e: string) => {
														return (
															<Tooltip title={e}>
																<Avatar
																	sx={{ height: "20px", width: "20px", marginRight: 0.5 }}
																	src={e}
																	alt={e}
																/>
															</Tooltip>
														);
													})}
												</Box>
											</Box>
										</Grid>

										<Grid item xs={2.4}>
											<Box>
												<Typography fontFamily="Gilroy-Regular" fontSize="12px" >
													Infra URLs
												</Typography>
												<Box display="flex" alignItems="center" justifyContent="flex-start">
													<Typography fontFamily="Gilroy-SemiBold" fontSize={14} sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis' , display:"flex", alignItems: "center"}}>
													2<Tooltip 
																							sx={{ whiteSpace: "pre-line" }}
																							// title={cluster.applications?.map(
																							// 	(e: any, index: number) => `${e.applicationName}`
																							// )}
																							title={
																								<>
																								<Typography fontFamily="Gilroy-Regular" fontSize="14px" fontWeight={700}>
													
																									Infra URL
																								</Typography>
																									<br />
																									{resourceStatus.resourceId === id && resourceStatus.projectUrl ? (
																										<Link
																											href={resourceStatus.projectUrl}
																											target="_blank"
																											rel="noopener noreferrer"
																											sx={{
																												textDecoration: 'underline', // Ensure underline for link appearance
																												color: 'inherit' // Inherit color from Typography, or set explicitly if needed
																											}}
																										>
																											<Typography
																												fontFamily="Gilroy-Bold"
																												fontSize="12px"
																												// Apply link color here if 'inherit' doesn't work as expected,
																												// or if you want a specific link color different from default Typography.
																												// For example: color: '#ADD8E6' (light blue)
																											>
																												App URL
																											</Typography>
																										</Link>
																									) : (
																										// If no link available (loading state), display the label as plain text
																										<Typography fontFamily="Gilroy-Regular" fontSize="12px">
																														App URL
																									
																										</Typography>
																									)}
													
																									{/* <Typography fontFamily="Gilroy-Regular" fontSize="12px">
																							App URL
																						</Typography>
																						<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#FFFFFF' }}>
																							{resourceStatus.resourceId === id ? (
																								<Link href={resourceStatus.projectUrl} 
																								target="_blank" rel="noopener noreferrer" sx={{ textDecoration: 'underline', color: '#FFFFFF' }}> 
																								{`${resourceStatus.projectUrl.substring(0,10)}...`} 
																								</Link>
																										) : (
																									<>Loading...</>
																											)}
																								</Typography> */}
																									<br/>
																									{resourceStatus.resourceId === id && resourceStatus.subGroupProjectInfraUrl ? (
																										<Link
																											href={resourceStatus.subGroupProjectInfraUrl}
																											target="_blank"
																											rel="noopener noreferrer"
																											sx={{
																												textDecoration: 'underline', // Ensure underline for link appearance
																												color: 'inherit' // Inherit color from Typography, or set explicitly if needed
																											}}
																										>
																											<Typography
																												fontFamily="Gilroy-Bold"
																												fontSize="12px"
																												// Apply link color here if 'inherit' doesn't work as expected,
																												// or if you want a specific link color different from default Typography.
																												// For example: color: '#ADD8E6' (light blue)
																											>
																												K8s Infra URL
																											</Typography>
																										</Link>
																									) : (
																										// If no link available (loading state), display the label as plain text
																										<Typography fontFamily="Gilroy-Regular" fontSize="12px">
																														K8s Infra URL
																									
																										</Typography>
																									)}
													
																									{/* <Typography fontFamily="Gilroy-Regular" fontSize="12px">
																							K8s Infra URL
																						</Typography>
																						<Typography fontFamily="Gilroy-SemiBold" fontSize="14px" sx={{ wordWrap: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis', color: '#FFFFFF' }}>
																							{resourceStatus.resourceId === id ? (
																								<Link href={resourceStatus.subGroupProjectInfraUrl} 
																								target="_blank" rel="noopener noreferrer" sx={{ textDecoration: 'underline', color: '#FFFFFF' }}> 
																								{`${resourceStatus.subGroupProjectInfraUrl.substring(0,10)}...`} 
																								</Link>
																										) : (
																									<>Loading...</>
																											)}
																								</Typography> */}
													
																									<br/>
													
																								
													
																								</>
																							}
																							slotProps={{ tooltip: { sx: { bgcolor: '#333333' } } }}
																						>
																							<Avatar
																								src="/assets/info.svg"
																								alt="info"
																								sx={{ height: 16, width: 16, marginLeft: "4px" }}
																							/>
																							
																						</Tooltip>
																						</Typography>
												</Box>
											</Box>
										</Grid>
										
									</Grid>
									<Box>
										<Typography gutterBottom fontFamily="Gilroy-Regular" fontSize="12px" mt={2}>
											Tags/ Labels
										</Typography>
										<Box ml={-0.5}>
											{application.costLabelPairs?.map((e: any) => {
												return (
													<Chip
														size="small"
														sx={{
															bgcolor: "#10101010",
															border: "1px solid black",
															mr: 0.75,
															fontFamily: "Gilroy-Regular",
															fontSize: "12px",
														}}
														variant="filled"
														label={`${e.cost} • ${e.label}`}
													/>
												);
											})}
										</Box>
									</Box>
								</Box>
							</Box>
						</Box>
					)}
					{application.status == "rejected" && (
						<Box bgcolor="#fff" p={2} borderRadius="12px" boxShadow={1} mt={2} mx={4}>
							<Typography fontSize="14px">Cloud Infra Details</Typography>
							<Divider sx={{ my: 2 }} />
							{application.status == "rejected" && (
								<Grid container>
									<Grid item xs={2.4}>
										<Box>
											<Typography fontFamily="Gilroy-Regular" fontSize="12px">
												Reason for rejection
											</Typography>
											<Typography fontFamily="Gilroy-Semibold" fontSize="14px">
												{application.reasonForRejection}
											</Typography>
										</Box>
									</Grid>
								</Grid>
							)}
						</Box>
					)}
					{application.status == "pending" &&
						user.roles.some((element: string) => ["infrastructure_admin"].includes(element)) && (
							<Box display="flex" justifyContent="flex-end" gap={2} mt={4} pb={4} mr={4}>
								<Button
									sx={{
										color: "black",
										borderColor: "black",
										fontWeight: "bold",
										textTransform: "none",
										px: 4,
										fontFamily: "Gilroy-Bold",
										fontSize: "14px",
									}}
									variant="outlined"
									size="large"
									onClick={() => {
										setOpenRejectModal(true);
									}}
								>
									Reject Request
								</Button>
								<Button
									sx={{
										backgroundColor: "black",
										color: "white",
										fontWeight: "bold",
										"&:hover": {
											backgroundColor: "white",
											color: "black",
											borderColor: "black",
										},
										textTransform: "none",
										px: 4,
										fontFamily: "Gilroy-Bold",
										fontSize: "14px",
									}}
									variant="contained"
									size="large"
									onClick={() => {
										setOpenApproveModal(true);
									}}
								>
									Approve Request
								</Button>
							</Box>
						)}
					<Modal
						open={openApproveModal}
						onClose={(event, reason): any => {
							// if (reason && reason === "backdropClick") return;
							// setOpenRejectModal(false);
						}}
					>
						<Box
							sx={{
								position: "absolute",
								top: "50%",
								left: "50%",
								transform: "translate(-50%, -50%)",
								width: 700,
								bgcolor: "white",
								border: "0px",
								boxShadow: 2,
								borderRadius: "16px",
							}}
						>
							<Box display="flex" justifyContent="space-between">
								<Typography fontFamily="Gilroy-SemiBold" fontSize="20px" p={2}>
									Approve
								</Typography>
								<IconButton
									edge="start"
									aria-label="back"
									color="inherit"
									onClick={async () => {
										setOpenApproveModal(false);
									}}
									sx={{ m: 2 }}
								>
									<Close fontSize="small" />
								</IconButton>
							</Box>
							<Divider />
							 <Typography fontSize="16px" p={2}>
								Are you sure you want to approve the request?
							</Typography>
							<Typography fontSize="16px" p={2}>
								On approving, the resources mentioned below would be provisioned.
							</Typography>
							<DialogContent sx={{ p: 2, maxHeight: '400px', overflowY: 'auto', backgroundColor:'#FAFAFA', marginX:'1vw', marginBottom:'1vh', borderRadius:'16px'}}>
            <Grid container spacing={2} rowSpacing={1}> {/* Add spacing between grid items, adjusted row spacing */}

                {/* Namespace */}
                <Grid item xs={12} sm={6}> {/* Takes full width on xs, half on sm and up */}
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                        Namespace
                    </Typography>
                    <Typography variant="body1" color="text.primary">
                        { (application?.applicationName && application?.environment)
                          ? `${application.applicationName}-${application.environment}`
                          : fallback }
                    </Typography>
                </Grid>

                {/* Kubernetes Service Account */}
                <Grid item xs={12} sm={6}> {/* Takes full width on xs, half on sm and up */}
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                        Kubernetes Service Account
                    </Typography>
                    <Typography variant="body1" color="text.primary">
                        { (application?.applicationName && application?.environment)
                          ? `${application.applicationName}-${application.environment}-sa`
                          : fallback }
                    </Typography>
                </Grid>

                {/* Repo URL */}
                <Grid item xs={12} sm={6}> {/* Takes full width on xs, half on sm and up */}
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                        Subgroup Name 
                    </Typography>
                    <Typography
                        variant="body1"
                        color="text.primary"
                        sx={{ wordBreak: 'break-all' }} // Prevent long URLs from overflowing
                    >
                         { application?.applicationName
                           ? application?.applicationName
                           : fallback }
                    </Typography>
					
                </Grid>

                {/* Workload Identity Mapped Service Account */}
                <Grid item xs={12} sm={6}> {/* Takes full width on xs, half on sm and up */}
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                        Workload Identity Mapped Service Account
                    </Typography>
                    <Typography
                        variant="body1"
                        color="text.primary"
                        sx={{ wordBreak: 'break-all' }} // Allow long SA names to wrap
                    >
                        { (application?.applicationName && application?.environment && application?.cluster?.vpcProjectId)
                          ? `${application.applicationName}-${application.environment}@${application.cluster.vpcProjectId}.iam.gserviceaccount.com`
                          : fallback }
                    </Typography>
                </Grid>

            </Grid>
        </DialogContent>
							<Divider />
							<Box sx={{ m: 2, textAlign: "right" }}>
								<Button
									sx={{
										backgroundColor: "black",
										color: "white",
										fontWeight: "bold",
										"&:hover": {
											backgroundColor: "white",
											color: "black",
											borderColor: "black",
										},
										textTransform: "none",
										px: 4,
										fontFamily: "Gilroy-Bold",
										fontSize: "14px",
									}}
									variant="contained"
									size="small"
									onClick={async () => {
										const data = await queryGraphql(
											`
                                                            mutation ApproveApplication($input: ApplicationApproveInput!) {
															approveApplication(input: $input) {
																id
															}
															}
                                    `,
											{
												input: {
													id: application.id,
												},
											}
										);

										const info = await queryGraphql(`mutation Mutation($input: ResourceStatusUpdateInput) {
											updateResourceStatus(input: $input) {
												id
											}
											}`, {
												input: {
												  currentStatus: "active",
												  resourceId: id
												}
											  });
			

										if (data.approveApplication.id && info.updateResourceStatus.id) {
											setOpenApproveModal(false);
											navigate("/requests/applications");
										}
									}}
								>
									Approve
								</Button>
							</Box>
						</Box>
					</Modal>
					<Modal
						open={openRejectModal}
						onClose={(event, reason): any => {
							// if (reason && reason === "backdropClick") return;
							// setOpenRejectModal(false);
						}}
					>
						<Box
							sx={{
								position: "absolute",
								top: "50%",
								left: "50%",
								transform: "translate(-50%, -50%)",
								width: 700,
								bgcolor: "white",
								border: "0px",
								boxShadow: 2,
								borderRadius: "16px",
							}}
						>
							<Formik
								onSubmit={async ({ reasonForRejection }) => {
									const data = await queryGraphql(
										`
														mutation RejectApplication($input: ApplicationRejectInput!) {
														rejectApplication(input: $input) {
															id
														}
														}
								`,
										{
											input: {
												id: application.id,
												reasonForRejection,
											},
										}
									);

									const info = await queryGraphql(`mutation Mutation($input: ResourceStatusUpdateInput) {
										updateResourceStatus(input: $input) {
											id
										}
										}`, {
											input: {
											  currentStatus: "rejected",
											  resourceId: id
											}
										  });
		

									if (data.rejectApplication.id && info.updateResourceStatus.id) {
										navigate("/requests/applications");
									}
								}}
								validationSchema={Yup.object().shape({
									reasonForRejection: Yup.string()
										.required("This field is required")
										.matches(/^[a-zA-Z0-9-\s]*$/, "This field must be alphanumeric")
										.strict(),
								})}
								initialValues={{ reasonForRejection: "" }}
							>
								{({
									handleChange,
									handleBlur,
									values,
									setFieldValue,
									errors,
									touched,
									isValid,
									dirty,
								}) => {
									return (
										<Form id="reject-form">
											<Box display="flex" justifyContent="space-between">
												<Typography fontFamily="Gilroy-SemiBold" fontSize="20px" p={2}>
													Reject Request
												</Typography>
												<IconButton
													edge="start"
													aria-label="back"
													color="inherit"
													onClick={() => setOpenRejectModal(false)}
													sx={{ m: 2 }}
												>
													<Close fontSize="small" />
												</IconButton>
											</Box>
											<Divider />
											<Typography fontSize="16px" p={2}>
												Add comments for the requestor explaining the reason of rejection
											</Typography>
											<Box p={2}>
												<CompulsoryFieldsLabel fieldName="Comments" />
												<TextField
													sx={{
														"& .MuiFilledInput-root": {
															border:
																errors["reasonForRejection"] && touched["reasonForRejection"]
																	? "1px solid red"
																	: "1px solid #00000000",

															"&.Mui-focused": {
																backgroundColor: "white",
																border: "1px solid black",
															},
														},
													}}
													variant="filled"
													fullWidth
													multiline
													name="reasonForRejection"
													value={values.reasonForRejection}
													onChange={handleChange}
													onBlur={handleBlur}
													placeholder="Enter comment"
													size="medium"
													hiddenLabel
													InputProps={{
														disableUnderline: true,

														style: {
															borderRadius: "8px",
														},
													}}
												/>
												<div style={{ color: "red", marginTop: "8px", marginLeft: "4px" }}>
													<ErrorMessage name="reasonForRejection" component="div" />
												</div>
											</Box>

											<Box sx={{ m: 2, textAlign: "right" }}>
												<Button
													sx={{
														backgroundColor: "black",
														color: "white",
														fontWeight: "bold",
														"&:hover": {
															backgroundColor: "white",
															color: "black",
															borderColor: "black",
														},
														textTransform: "none",
														px: 4,
														fontFamily: "Gilroy-Bold",
														fontSize: "14px",
													}}
													variant="contained"
													size="small"
													type="submit"
													form="reject-form"
													disabled={!(isValid && dirty)}
												>
													Reject
												</Button>
											</Box>
										</Form>
									);
								}}
							</Formik>
						</Box>
					</Modal>
				</Grid>
				<Grid item xs={0.5} />
			</Grid>
		</Container>
	);
};

//export default ApplicationApproveFormPage;


const ApplicationApproveFormPage: React.FC = () => {
    const theme = useTheme();

    const getInitialDrawerState = () => {
        if (typeof window !== 'undefined') {
            const storedState = localStorage.getItem('isFaradayDrawerOpen');
            return storedState !== null ? JSON.parse(storedState) : true;
        }
        return true;
    };
    const [isDrawerActuallyOpen, setIsDrawerActuallyOpen] = useState<boolean>(getInitialDrawerState);

    const handleDrawerStateChange = (isOpenFromDrawer: boolean) => {
        setIsDrawerActuallyOpen(isOpenFromDrawer);
    };

    // Using your remembered calculation for marginLeft
    const currentMarginLeft = isDrawerActuallyOpen ? openDrawerWidth - 248 : collapsedDrawerWidth - 70;

    return (
        <Box sx={{ display: 'flex', minHeight: '100vh' }}>
            <MainDrawer
                // Assuming "integrations" is the correct index for Kyverno page
                // If Kyverno has its own top-level menu item, update this index.
                index={"requests-application"} // Or a more specific index like "integrations-kyverno" if applicable
                onStateChange={handleDrawerStateChange}
            />
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    // bgcolor: '#fafafa', // bgcolor commented out as per your previous change
                    p: 0,
                    transition: theme.transitions.create('margin', {
                        easing: theme.transitions.easing.sharp,
                        duration: theme.transitions.duration.enteringScreen,
                    }),
                    // Using your remembered unit and calculation for marginLeft
                    marginLeft: `${currentMarginLeft}vh`,
                }}
            >
                <ApplicationApproveFormPageContent />
            </Box>
        </Box>
    );
};

export default ApplicationApproveFormPage;